<template>
  <l-layout :layout="['xs12']">
    <v-card>
      <l-data-table
        ref="classList"
      :headers="header"
      title-text="标签类型列表"
      :get-data-func="getClassList"
      clickable
      @click:row="getDetails($event.item)"
      >
        <template slot="row-action" slot-scope="{item}">
          <td @click.stop class="px-0 mx-0 text-xs-center">
            <v-tooltip left>
              <v-btn @click="deleteClassConfirm(item)" slot="activator" icon>
                <v-icon small>$vuetify.icons.delete</v-icon>
              </v-btn>
              <span>删除标签类型</span>
            </v-tooltip>
          </td>
        </template>
      </l-data-table>
      <l-fixed-btn
        @click="addClass"
        icon="$vuetify.icons.add"
      ></l-fixed-btn>
    </v-card>
  </l-layout>
</template>

<script>
export default {
  name: 'MessageClass',
  data () {
    return {
      header: [
        {text: '类型名称', value: 'name', align: 'left', sortable: false},
        {text: '创建者', value: 'creator', align: 'left', sortable: false},
        {text: '创建时间', value: 'creationTime', align: 'left', sortable: true, f: (v) => (this.$L.time.stringify(v))},
        {text: '', value: '', align: 'left', sortable: false}
      ]
    }
  },
  computed: {
    refresh () {
      //console.log(this.$store.state.message.classRefresh)
      return this.$store.state.message.classRefresh
    }
  },
  activated () {
    if (this.refresh) {
      this.$refs.classList.refresh()
      this.$store.commit('message/setClassRefresh', false)
    }
  },
  methods: {
    async getClassList ({pagination, sortStack, filterItems, search}) {
      let url = '/messageApi/admin/getMsgLabelType'
      let {items, amount} = await this.$store.dispatch('message/getList', {pagination, sortStack, filterItems, search: {key: 'name', value: search}, url: url})
      return {items, amount}
    },
    addClass () {
      this.$router.push({name: 'newMessageClass'})
    },
    getDetails (item) {
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        this.$router.push({
          name: 'classDetailBox',
          query: {id: item.id}
        })
      }
    },
    async deleteClassConfirm (item) {
      let {res, close} = await this.$L.confirm({
        title: '确认删除该标签类型？',
        text: '类型名称:' + item.name
      })
      if (res) {
        try {
          await this.deleteClass(item)
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    async deleteClass (item) {
      let url = '/messageApi/admin/deleteMsgLabelType'
      let ids = []
      ids.push(item.id)
      let params = {'idList': ids}
      let res = await this.$store.dispatch('message/deleteActions', {params: params, url: url})
      if (res.data.code + '' === '200') {
        this.$L.alert('success', {message: '删除成功'})
        this.$refs.classList.refresh()
      }
      else {
        this.$L.alert('error', {message: '删除失败，原因：' + res.data.msg})
      }
    },
  }
}
</script>

<style scoped>

</style>
